<template>
  <div>
    <LayoutContent>
      <v-container class="rounded-lg elevation-3 d-flex flex-column align-center" v-if="voucher">
        <div class="mt-15 text-h4 font-weight-bold primary--text text--darken-1">{{ voucher.name }}</div>
        <VueQrcode class="mt-10" :value="voucher.code" :options="{ margin: 1, width: 200 }"></VueQrcode>
        <div class="mt-10 text-body font-weight-medium grey--text">{{ $t('label.voucherCode') }}</div>
        <div class="mt-1 text-h6 font-weight-bold dark-grey--text">{{ voucher.code }}</div>
        <div class="d-flex align-center full-width">
          <v-divider></v-divider>
          <app-button invert gradient :label="`${$t('label.expireDate')}: ${voucher.redeem_end_date}`" width="18rem" class="my-8" />
          <v-divider></v-divider>
        </div>
        <div class="text-body font-weight-medium grey--text">{{ $t('label.value') }}</div>
        <div class="text-h6 font-weight-bold dark-grey--text">{{ voucher.display_value }}</div>
        <v-divider class="my-8 full-width"></v-divider>
        <div class="text-body font-weight-medium grey--text">{{ $t('label.termsAndConditions') }}</div>
        <div class="tnc text-h6 font-weight-medium dark-grey--text">{{ voucher.description }}</div>
        <div class="mt-16 text-body font-weight-medium grey--text">{{ $t('label.contactUs') }}:</div>
        <a class="main-link" :href="`mailto:${customerServiceEmail}`">{{ customerServiceEmail }}</a>
      </v-container>
    </LayoutContent>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LayoutContent from '../layouts/LayoutContent.vue'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import { AUTH } from '@/api'

export default {
  components: { LayoutContent, VueQrcode },
  props: ['id'],
  data: () => ({
    voucher: null
  }),
  computed: {
    ...mapGetters('page', ['customerServiceEmail'])
  },
  created() {
    this.getVoucherHistory()
  },
  methods: {
    getVoucherHistory() {
      AUTH.getVoucher({ type: this.$route.hash.replace('#', '') }).then((res) => {
        let newRes = res.voucher.filter((f) => f.voucher_id === Number(this.id))
        if (newRes.length > 0) this.voucher = newRes[0]
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.tnc {
  margin-left: 20%;
  margin-right: 20%;
}
.full-width {
  width: 100%;
}
</style>
